export default function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}


//////////////////
// WEBPACK FOOTER
// /data/websites/sparkasse.it/httpdocs/wp-content/themes/g2k-sparkasse/sito-investor-relations/node_modules/swiper/core/translate/maxTranslate.js
// module id = 99
// module chunks = 0